import { render, staticRenderFns } from "./pushdown.vue?vue&type=template&id=18412fe8&scoped=true&"
import script from "./pushdown.vue?vue&type=script&lang=js&"
export * from "./pushdown.vue?vue&type=script&lang=js&"
import style0 from "./pushdown.vue?vue&type=style&index=0&id=18412fe8&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18412fe8",
  null
  
)

export default component.exports